export default __webpack_public_path__ + "static/media/2021 _CV_Final_Project.919fad17.pdf";